// Every report-param key the brand perceptual mapping block can persist, each set to null.

import { buildClearParams } from '@aytm/app/stats/page/question-views/components/lib/clear-params'

const QUESTION_PARAMS = ['bpm', 's']

export const calcClearParams = ({ questionKey, answerVariants, batches, clusters } = {}) =>
  buildClearParams({ questionKey, answerVariants, batches, clusters, question: QUESTION_PARAMS })
